import React, { type ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { Divider, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useAppSelector } from 'store/hooks'
import { formatNumber } from 'common/utils/functions'

import styles from './InfoPanel.module.scss'

interface InfoProps {
  label: string
  value?: string
  colorGray: string
  colorWhite: string
}
const InfoPanel: React.FC = (): ReactElement => {
  const { palette } = useTheme()
  const { vendor } = useAppSelector((state) => state.vendor)
  const { decisionDetails } = useAppSelector((state) => state.vendor)

  const createInfoItem = ({ label, value, colorGray, colorWhite }: InfoProps): ReactElement => {
    return (
      <div className={styles.infoItem}>
        <Typography variant="title4" sx={{ color: colorGray }}>
          {label}
        </Typography>
        <Typography variant="title5" sx={{ color: colorWhite }}>
          {value ?? '-'}
        </Typography>
      </div>
    )
  }

  return vendor ? (
    <div className={styles.container}>
      <Typography variant="title1" sx={{ color: palette.white.main, paddingInline: '20px' }}>
        Osnovne informacije o vendoru
      </Typography>
      <Divider className={styles.divider} flexItem />
      <div className={styles.infoContainer}>
        {createInfoItem({
          label: 'Ime kompanije',
          value: vendor.name,
          colorGray: palette.gray.main,
          colorWhite: palette.white.main,
        })}
        {createInfoItem({
          label: 'Delatnost kompanije',
          value: `${vendor.industry?.name ?? ''} (${vendor.industry?.code ?? ''})`,
          colorGray: palette.gray.main,
          colorWhite: palette.white.main,
        })}
        {createInfoItem({
          label: 'Email kompanije',
          value: vendor.aprEmail,
          colorGray: palette.gray.main,
          colorWhite: palette.white.main,
        })}
        <div className={styles.itemRow}>
          <div className={`${styles.infoPhoneItem} ${styles.infoItem}`}>
            <Typography variant="title4" sx={{ color: palette.gray.main, paddingBottom: '5px' }}>
              Broj telefona kompanije
            </Typography>
            {vendor.phones?.length ? (
              vendor.phones.map((phone) => (
                <Typography key={phone} variant="title5" sx={{ color: palette.white.main }}>
                  {phone}
                </Typography>
              ))
            ) : (
              <Typography variant="title4" sx={{ color: palette.gray.main, paddingBottom: '5px' }}>
                -
              </Typography>
            )}
          </div>
          {createInfoItem({
            label: 'PIB',
            value: vendor.tin,
            colorGray: palette.gray.main,
            colorWhite: palette.white.main,
          })}
        </div>
        {createInfoItem({
          label: 'Prihod kompanije za prošlu godinu',
          value: decisionDetails?.incomeLastYear ? formatNumber(decisionDetails?.incomeLastYear) : '-',
          colorGray: palette.gray.main,
          colorWhite: palette.white.main,
        })}
        <div className={styles.itemRow}>
          {createInfoItem({
            label: 'Matični broj',
            value: vendor?.cid,
            colorGray: palette.gray.main,
            colorWhite: palette.white.main,
          })}
          <div className={`${styles.infoPhoneItem} ${styles.infoItem}`}>
            <Typography variant="title4" sx={{ color: palette.gray.main, paddingBottom: '5px' }}>
              Website
            </Typography>
            {vendor?.website ? (
              <Link to={vendor?.website} target="_blank" rel="noopener noreferrer">
                <Typography
                  variant="title5"
                  sx={{
                    color: palette.white.main,
                    maxWidth: '290px',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                  }}
                >
                  {vendor.website}
                </Typography>
              </Link>
            ) : (
              <Typography variant="title4" sx={{ color: palette.gray.main, paddingBottom: '5px' }}>
                -
              </Typography>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default InfoPanel
